"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function TherapistError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    try {
      import("posthog-js").then(({ default: posthog }) => {
        posthog.captureException(error, {
          source: "therapist-profile-error-boundary",
          digest: error.digest ?? null,
          ua: typeof navigator !== "undefined" ? navigator.userAgent : null,
          pathname:
            typeof window !== "undefined" ? window.location.pathname : null,
        });
      });
    } catch {
      /* posthog not available */
    }
    console.error("[TherapistError]", error);
  }, [error]);

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        textAlign: "center",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div style={{ maxWidth: 400 }}>
        <h2 style={{ fontSize: "1.1rem", fontWeight: 700, color: "#264653", marginBottom: "0.5rem" }}>
          Pagina nu s-a putut încărca
        </h2>
        <p style={{ fontSize: "0.875rem", color: "rgba(38,70,83,0.65)", marginBottom: "1.25rem" }}>
          Reîncarcă pagina sau revino la lista de terapeuți.
        </p>
        {process.env.NODE_ENV !== "production" && (
          <pre
            style={{
              background: "#fee2e2",
              color: "#991b1b",
              padding: "0.5rem",
              borderRadius: "0.5rem",
              fontSize: "0.7rem",
              textAlign: "left",
              overflowX: "auto",
              marginBottom: "1rem",
            }}
          >
            {error.message}
          </pre>
        )}
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
          <button
            onClick={reset}
            style={{
              padding: "0.5rem 1rem",
              background: "#2C969B",
              color: "#fff",
              border: "none",
              borderRadius: "999px",
              fontWeight: 600,
              fontSize: "0.875rem",
              cursor: "pointer",
            }}
          >
            Reîncearcă
          </button>
          <Link
            href="/terapeuti"
            style={{
              padding: "0.5rem 1rem",
              color: "#264653",
              border: "1px solid rgba(38,70,83,0.2)",
              borderRadius: "999px",
              fontWeight: 600,
              fontSize: "0.875rem",
              textDecoration: "none",
            }}
          >
            Toți terapeuții
          </Link>
        </div>
      </div>
    </div>
  );
}
